import { merge } from 'ramda';
import {
  REQUEST, FAIL, SUCCESS, OPTIONS_SUCCESS
} from 'src/store/actions/userActions';

const initialState = {
  list: [],
  options: [],
  fetching: false,
  errors: []
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case FAIL:
      return merge(state, { fetching: false, errors: action.error });
    case SUCCESS:
      return merge(state, { fetching: false, list: action.users });
    case OPTIONS_SUCCESS:
      return merge(state, { options: action.usersOptions });
    default:
      return state;
  }
};

export default usersReducer;
